define.alias("ember-functions-as-helper-polyfill/initializers/install-function-helper-manager", "calendar/initializers/install-function-helper-manager");